export const BREADCRUMBS = [{ label: 'Companies' }];
